import { formatVenueDateTime } from '../../../shared/venueZoneFormatting';

export const upcomingPriceText = (ticketType, formatter) => {
  const upcoming = ticketType && ticketType.upcoming_price;
  if (!upcoming) { return null; }
  if (ticketType.free) { return null; }
  if (ticketType.sales_ended) { return null; }

  const current = Number(ticketType.calculated_price);
  const next = Number(upcoming.calculated_price != null ? upcoming.calculated_price : upcoming.price);
  if (next === current) { return null; }

  return `Price ${next > current ? 'increases' : 'changes'} to ${formatter.format(next)} on ${formatVenueDateTime(upcoming.starts_at, { month: 'long' })}`;
};
